import { MAXIMUN_INPUT_VALUE } from 'utils/consts';
import * as Yup from 'yup';

const validadeValue = (value) => {
  if (!value) return true;
  return value <= MAXIMUN_INPUT_VALUE;
};

const messageTest = 'O valor não pode ser maior que 100.000.000';

export const remittanceSchema = Yup.object({
  lots: Yup.array(Yup.object().shape({
    name: Yup.string()
      .max(49, 'Máximo de caracteres (50 caracteres).')
      .required('Campo Obrigatório'),
    specie: Yup.object()
      // .max(49, 'Máximo de caracteres (50 caracteres).')
      .required('Campo Obrigatório').nullable(),
    size: Yup.string()
      .min(0, 'Precisa ser acima de 0')
      .max(9, 'Máximo de números (9 números).')
      .required('Campo Obrigatório')
      // .transform((value, originalValue) => (originalValue ? originalValue.replace(/\./g, '') : value))
      .test(
        'max-value',
        'O valor não pode ser maior que 100.000.000',
        (value) => {
          if (!value) return true;
          return value <= 100000000;
        },
      )
      .typeError('A quantidade de animais deve ser um número'),
    old: Yup.string()
      .min(0, 'Precisa ser acima de 0')
      .max(3, 'Máximo de caracteres (3 caracteres).')
      .required('Campo Obrigatório'),
    price: Yup.number()
      .required('Campo Obrigatório')
      .test('max-value', messageTest, validadeValue)
      .test('zero-value', 'Insira o preço.', (value) => value !== 0)
      .test('greater-than-zero', 'Preço deve ser maior que 0.', (value) => value > 0)
      .typeError('O preço deve ser um valor válido'),
  })),
});
